import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconExport = ({ id, color, width = 15, style, ...restProps }: IProps) => {
  const viewBoxWidth = 15;
  const viewBoxHeight = 19;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M8.28 2.535v11.428c0 .448-.331.812-.74.812-.407 0-.738-.364-.738-.812V2.535L5.12 4.215A.747.747 0 0 1 4.065 3.16L7.013.218a.743.743 0 0 1 1.055 0l2.948 2.943a.744.744 0 0 1-.527 1.272.744.744 0 0 1-.528-.219L8.28 2.535zM14.021 19H.753C.337 19 0 18.678 0 18.282V8.106c0-.397.337-.718.753-.718h3.784c.415 0 .753.321.753.718 0 .396-.338.718-.753.718H1.506v8.74h11.763v-8.74h-3.087c-.416 0-.753-.322-.753-.718 0-.397.337-.718.753-.718h3.84c.416 0 .753.321.753.718v10.176c0 .396-.337.718-.753.718z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconExport;
